import { render, staticRenderFns } from "./projectTypeArchive.vue?vue&type=template&id=6767f194&"
import script from "./projectTypeArchive.vue?vue&type=script&lang=js&"
export * from "./projectTypeArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports